export default "__VITE_ASSET__B1Hop6JY__"